/**
 * Vocabulario de la navegación, compartido por la barra ancha y el menú angosto. Una entrada puede
 * llevar a otra ruta o cambiar de sección dentro de la misma página, y las dos se dibujan igual:
 * para quien las usa son destinos.
 */
interface EntradaMenu {
  texto: string;
  e2e?: string;
  /** Ruta a la que navega. Excluyente con `alElegir`. */
  ruta?: string;
  /** Exige que la ruta coincida completa, no por prefijo (la raíz lo necesita). */
  fin?: boolean;
  /** Sección de la misma página. Excluyente con `ruta`. */
  alElegir?: () => void;
  /** Para las de sección: si es la que se está viendo. Las de ruta lo deducen de la URL. */
  activa?: boolean;
}

export interface GrupoMenu {
  titulo: string;
  entradas: EntradaMenu[];
}

/** El aspecto de una entrada de navegación. Un solo sitio para que no vuelva a divergir. */
export function claseEntradaNav(activa: boolean): string {
  return `rounded-control min-h-11 inline-flex items-center px-3 py-2 text-contenido font-bold ${
    activa ? 'bg-primary text-primary-foreground' : 'hover:bg-surface'
  }`;
}

/** Igual, pero para el menú desplegable, donde las entradas ocupan todo el ancho. */
export function claseEntradaMenu(activa: boolean): string {
  return `rounded-control min-h-11 flex w-full items-center px-2 py-2 text-left text-contenido font-semibold ${
    activa ? 'bg-primary text-primary-foreground' : 'hover:bg-surface'
  }`;
}
